<template>
  <div class="gm-cycle" :class="{'gm-cycle--switching': switching}">
    <div class="gm-cycle__cycle">
      <span class="gm-eyebrow">Cycle</span>
      <span class="gm-cycle__number">{{ currentTurn ?? '—' }}</span>
    </div>
    <span v-if="switching" class="gm-cycle__phase gm-cycle__phase--switching" role="status" aria-live="polite">
      <span class="dx-loader dx-loader--xs" aria-hidden="true"></span>
      Switching
    </span>
    <span v-else class="gm-cycle__phase" :class="phaseModifier">{{ phaseLabel }}</span>
  </div>
</template>

<script>
export default {
  name: "GmCycleStatus",
  props: {
    currentTurn: {type: Number, default: null},
    currentPhase: {type: String, default: null},
    switching: {type: Boolean, default: false},
  },
  computed: {
    phaseLabel() {
      if (!this.currentPhase) return "Idle";
      return this.currentPhase.charAt(0).toUpperCase() + this.currentPhase.slice(1).toLowerCase();
    },
    phaseModifier() {
      return `gm-cycle__phase--${(this.currentPhase || 'idle').toLowerCase()}`;
    },
  },
};
</script>

<style scoped>
.gm-cycle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--gm-gap-sm);
  padding: var(--gm-gap-xs) var(--gm-gap-sm);
  background: var(--gm-surface-2);
  border: 1px solid var(--gm-border-dim);
  border-radius: var(--gm-radius-sm);
}

.gm-cycle__cycle {
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
  min-width: 0;
}

.gm-cycle__number {
  font-family: var(--gm-font-display);
  font-size: 0.95rem;
  font-weight: 700;
  line-height: 1;
  letter-spacing: 0.06em;
  color: var(--gm-accent);
}

.gm-cycle__phase {
  flex: none;
  font-family: var(--gm-font-display);
  font-size: 0.58rem;
  font-weight: 600;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  padding: 0.2rem 0.45rem;
  border-radius: 999px;
  border: 1px solid currentColor;
  color: var(--gm-text-muted);
}

.gm-cycle__phase--action {
  color: var(--gm-accent-hi);
  background: var(--gm-accent-softer);
}

.gm-cycle__phase--preparation {
  color: var(--gm-info);
}

.gm-cycle__phase--switching {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  color: var(--gm-accent-hi);
}

.gm-cycle--switching {
  border-color: var(--gm-accent);
  animation: gm-cycle-pulse 1.4s ease-in-out infinite;
}

@keyframes gm-cycle-pulse {
  0%, 100% { background: var(--gm-surface-2); }
  50% { background: var(--gm-accent-softer); }
}

@media (prefers-reduced-motion: reduce) {
  .gm-cycle--switching {
    animation: none;
  }
}
</style>
